import { put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';

import {
  LOAD_ATTENDANCECONTROL,
  CHANGE_ATTENDANCECONTROL,
  LOAD_COURSE
} from './constants';

import {
  loadAttendanceError,
  loadAttendanceSuccess,
  changeAttendanceError,
  changeAttendanceSuccess,
  // course
  loadCourseSuccess,
  loadCourseError,
} from './actions';

// utils
import api from "utils/api";
const { endpoint } = api;
import _local from 'utils/localStorageUtils';


export function* loadAttendanceControl(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();

    const { id } = action;

    // we get the campaigns linked to the attendanceControl
    const attendanceControlData = yield requestWrapper(
      'GET',
      endpoint?.attendances?.single(id),
      '',
      currentUser.token,
    );

    if (!attendanceControlData) {
      yield put(loadAttendanceSuccess(false));
    } else {
      yield put(loadAttendanceSuccess(attendanceControlData));
    }
  } catch (error) {
    yield put(loadAttendanceError(error));
  }
}

export function* changeAttendanceControl(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { attendanceData, timeZone } = action;

    let changedAttendanceControl = false,
      isNew = !attendanceData?._id;

    if (!!isNew) {
      changedAttendanceControl = yield requestWrapper(
        'POST',
        endpoint?.attendances?.new,
        {...attendanceData, timeZone},
        currentUser.token,
      );
     // notification.success({ message: 'Created' });
    } else {
      changedAttendanceControl = yield requestWrapper(
        'PATCH',
        endpoint?.attendances?.update,
        {...attendanceData, timeZone},
        currentUser.token,
      );
     // notification.success({ message: 'Updated' });
    }

    if (!changedAttendanceControl) {
      yield put(changeAttendanceSuccess(false));
    } else {
      // if new we update the url, item props will be updated
      if (isNew) {
        //history.push({ pathname: `/attendanceControl/`+attendanceControlData._id });
      }
      yield put(changeAttendanceSuccess(changedAttendanceControl));
    }
  } catch (error) {
    yield put(changeAttendanceError(error));
  }
}

export function* loadCourseSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { role } = currentUser;
    const { courseID, onDate, timeZone } = action;

    const isTeacher = role == 'teacher';

    let finalEndpoint = endpoint?.courses?.single(courseID);
    if (!!isTeacher) {
      finalEndpoint = endpoint?.courses?.teacher?.single(courseID);
    } else if (role == 'parent') { 
      finalEndpoint = endpoint?.courses?.parent?.single(courseID);
    } 

    // we get the campaigns linked to the courses
    let courseDetailSaga = yield requestWrapper(
      isTeacher ? 'POST' :'GET',
      finalEndpoint,
      {
        onDate,
        timeZone
      },
      currentUser.token,
    );

    if (!courseDetailSaga) {
      yield put(loadCourseSuccess(false));
    } else {
      yield put(loadCourseSuccess(courseDetailSaga, isTeacher));
    }
  } catch (error) {
    yield put(loadCourseError(error));
  }
}

export default function* attendanceControlSaga() {
  yield takeLatest(LOAD_ATTENDANCECONTROL, loadAttendanceControl);
  yield takeLatest(CHANGE_ATTENDANCECONTROL, changeAttendanceControl);
  yield takeLatest(LOAD_COURSE, loadCourseSaga);
}
